<aside class="sidebar d-none d-md-flex">

  <!-- Logo -->
  <div class="sidebar-logo">
    <a class="navbar-brand pe-3" style="cursor: pointer" routerLink="/">
      <img src="logo/agrify-ai-blue.png" class="img-fluid" alt="Agrify AI Logo" />
    </a>
  </div>

  <!-- Nav -->
  <ul class="nav-list">
    @if(isPrivileged(['IS_SELLER_ADMIN','IS_SELLER'])){
    <li class="nav-item">
      <a class="nav-link-item" (click)="openNewTrade()" routerLink="/seller/trade-gpt" routerLinkActive="active"
        #rlt="routerLinkActive" title="Trade GPT">
        <img [src]="rlt.isActive ? '/side-panel/Tradegpt-blue.svg' : '/side-panel/Tradegpt-gray.svg'" class="nav-icon"
          alt="" />
        Trade GPT
      </a>
    </li>

    <li class="nav-item">
      <a class="nav-link-item" routerLink="/seller/seller-catalog" routerLinkActive="active" #rlc="routerLinkActive"
        title="Catalog">
        <img [src]="rlc.isActive ? '/side-panel/Catalog-blue.svg' : '/side-panel/Catalog-gray.svg'" class="nav-icon"
          alt="" />
        Catalog
      </a>
    </li>

    <li class="nav-item">
      <a class="nav-link-item" routerLink="/seller/my-shipments" routerLinkActive="active" #rlo="routerLinkActive"
        title="Orders">
        <img [src]="rlo.isActive ? '/side-panel/MyOrders-blue.svg' : '/side-panel/MyOrders-gray.svg'" class="nav-icon"
          alt="" />
        Orders
      </a>
    </li>

     <!-- <li class="nav-item">
      <a class="nav-link-item" routerLink="/seller/verification-summary" routerLinkActive="active"
        #rlvsMember="routerLinkActive" title="Verification Summary">
        <img [src]="rlvsMember.isActive ? '/side-panel/Verify-user-blue.svg' : '/side-panel/Verify-user.svg'"
          class="nav-icon" alt="" />
        Verification Summary
      </a>
    </li> 
   

    <li class="nav-item">
      <a class="nav-link-item" routerLink="/seller/verification-list" routerLinkActive="active"
        #rlvlMember="routerLinkActive" title="Verification List">
        <img [src]="rlvlMember.isActive ? '/side-panel/MyRequirements-blue.svg' : '/side-panel/MyRequirements-gray.svg'"
          class="nav-icon" alt="" />
        Verification List
      </a>
    </li> -->

    } @else if(isPrivileged(['IS_BUYER'])){
    <li class="nav-item">
      <a class="nav-link-item" (click)="openNewTrade()" routerLink="/buyer/trade-gpt" routerLinkActive="active"
        #rlt="routerLinkActive" title="Trade GPT">
        <img [src]="rlt.isActive ? '/side-panel/Tradegpt-blue.svg' : '/side-panel/Tradegpt-gray.svg'" class="nav-icon"
          alt="" />
        Trade GPT
      </a>
    </li>

    <li class="nav-item">
      <a class="nav-link-item" routerLink="/buyer/catalog" routerLinkActive="active" #rlc="routerLinkActive"
        title="Catalog">
        <img [src]="rlc.isActive ? '/side-panel/Catalog-blue.svg' : '/side-panel/Catalog-gray.svg'" class="nav-icon"
          alt="" />
        Catalog
      </a>
    </li>

    <li class="nav-item">
      <a class="nav-link-item" routerLink="/buyer/quote" routerLinkActive="active" #rlq="routerLinkActive"
        title="Quotes">
        <img [src]="rlq.isActive ? '/side-panel/MyQuotes-blue.svg' : '/side-panel/MyQuotes-gray.svg'" class="nav-icon"
          alt="" />
        My Quotes
      </a>
    </li>

    <li class="nav-item">
      <a class="nav-link-item" routerLink="/buyer/buyer-orders" routerLinkActive="active" #rlo="routerLinkActive"
        title="Orders">
        <img [src]="rlo.isActive ? '/side-panel/MyOrders-blue.svg' : '/side-panel/MyOrders-gray.svg'" class="nav-icon"
          alt="" />
        My Orders
      </a>
    </li>

    <li class="nav-item">
      <a class="nav-link-item" routerLink="/buyer/requirement-list" routerLinkActive="active"
        #rlrMember="routerLinkActive" title="Requirements">
        <img [src]="rlrMember.isActive ? '/side-panel/MyRequirements-blue.svg' : '/side-panel/MyRequirements-gray.svg'"
          class="nav-icon" alt="" />
        My Requirements
      </a>
    </li>

    <!-- <li class="nav-item">
      <a class="nav-link-item" routerLink="/buyer/verification-summary" routerLinkActive="active"
        #rlvsMember="routerLinkActive" title="Verification Summary">
        <img [src]="rlvsMember.isActive ? '/side-panel/Verify-user-blue.svg' : '/side-panel/Verify-user.svg'"
          class="nav-icon" alt="" />
        Verification Summary
      </a>
    </li>
     <li class="nav-item">
      <a class="nav-link-item" routerLink="/buyer/verification-list" routerLinkActive="active"
        #rlvlMember="routerLinkActive" title="Verification List">
        <img [src]="rlvlMember.isActive ? '/side-panel/verification-list-blue.svg' : '/side-panel/verification-list.svg'"
          class="nav-icon" alt="" />
        Verification List
      </a>
    </li> -->
    <!-- <li class="nav-item">
      <a class="nav-link-item" routerLink="/buyer/verification-history" routerLinkActive="active"
        #rlvhMember="routerLinkActive" title="Verification History">
        <img [src]="rlvhMember.isActive ? '/side-panel/verification-history-blue.svg' : '/side-panel/verification-history.svg'"
          class="nav-icon" alt="" />
        Verification History
      </a>
    </li> -->

   


    } @else if (isRole(['SALES_TEAM'])){
       <li class="nav-item">
      <a class="nav-link-item" routerLink="/admin/callback-request" routerLinkActive="active"
        #rlcrMember="routerLinkActive" title="Callback Request">
        <img [src]="rlcrMember.isActive ? '/side-panel/MyRequirements-blue.svg' : '/side-panel/MyRequirements-gray.svg'"
          class="nav-icon" alt="" />
        Callback Request
      </a>
    </li>
        <li class="nav-item">
          
          <a class="nav-link-item" routerLink="/crm/online-list" routerLinkActive="active" #rlcrmMember="routerLinkActive"
            title="CRM Requests">
            <img [src]="rlcrmMember.isActive ? '/side-panel/canon-list-blue.svg' : '/side-panel/canon-list.svg'"
              class="nav-icon" alt="" />
            CRM Requests Online
          </a>
        </li>
        
        <li class="nav-item">
          <a class="nav-link-item" routerLink="/crm/offline-list" routerLinkActive="active"
            #rlcrmoMember="routerLinkActive" title="CRM Requests">
            <img [src]="rlcrmoMember.isActive ? '/side-panel/canon-list-blue.svg' : '/side-panel/canon-list.svg'"
              class="nav-icon" alt="" />
            CRM Requests Offline
          </a>
        </li>
    }
    
    @else if(isPrivileged(['ADMIN','SUPERADMIN'])){
    <li class="nav-item">
      <a class="nav-link-item" (click)="openNewTrade()" routerLink="/admin/trade-gpt" routerLinkActive="active"
        #rltr="routerLinkActive" title="Trade GPT">
        <img [src]="rltr.isActive ? '/side-panel/Tradegpt-blue.svg' : '/side-panel/Tradegpt-gray.svg'" class="nav-icon"
          alt="" />
        Trade GPT
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/admin/admin-dashboard" routerLinkActive="active" #rltb="routerLinkActive"
        title="Admin Dashboard">
        <img [src]="rltb.isActive ? '/icons/dashboard.svg' : '/icons/dashboard.svg'" class="nav-icon" alt="" />
        Dashboard
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/admin/master-catalog" routerLinkActive="active" #rltb="routerLinkActive"
        title="Browse">
        <img [src]="rltb.isActive ? '/side-panel/Catalog-blue.svg' : '/side-panel/Catalog-gray.svg'" class="nav-icon"
          alt="" />
        Browse
      </a>
    </li>

    <li class="nav-item">
      <a class="nav-link-item" routerLink="/admin/manage-orders" routerLinkActive="active" #rloMember="routerLinkActive"
        title="Orders">
        <img [src]="rloMember.isActive ? '/side-panel/MyOrders-blue.svg' : '/side-panel/MyOrders-gray.svg'"
          class="nav-icon" alt="" />
        Orders
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/admin/requirement-list" routerLinkActive="active"
        #rlrMember="routerLinkActive" title="Requirements">
        <img [src]="rlrMember.isActive ? '/side-panel/MyRequirements-blue.svg' : '/side-panel/MyRequirements-gray.svg'"
          class="nav-icon" alt="" />
        Requirements
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/admin/import-price-calculator" routerLinkActive="active"
        #rlrpcMember="routerLinkActive" title="Import Price Calculator">
        <img [src]="rlrpcMember.isActive ? '/side-panel/import-price-calculator-blue.svg' : '/side-panel/import-price-calculator-icon.svg'"
          class="nav-icon" alt="" />
        Import Price Calculator
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/admin/crm/online-list" routerLinkActive="active"
        #rlcrmMember="routerLinkActive" title="CRM Requests">
        <img [src]="rlcrmMember.isActive ? '/side-panel/canon-list-blue.svg' : '/side-panel/canon-list.svg'"
          class="nav-icon" alt="" />
        CRM Requests Online
      </a>
    </li>

    <li class="nav-item">
      <a class="nav-link-item" routerLink="/admin/crm/offline-list" routerLinkActive="active"
        #rlcrmoMember="routerLinkActive" title="CRM Requests">
        <img [src]="rlcrmoMember.isActive ? '/side-panel/canon-list-blue.svg' : '/side-panel/canon-list.svg'"
          class="nav-icon" alt="" />
        CRM Requests Offline
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/admin/verification-summary" routerLinkActive="active"
        #rlvsMember="routerLinkActive" title="Verification Summary">
        <img [src]="rlvsMember.isActive ? '/side-panel/Verify-user-blue.svg' : '/side-panel/Verify-user.svg'"
          class="nav-icon" alt="" />
        Verification Summary
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/admin/verification-list" routerLinkActive="active"
        #rlvlistMember="routerLinkActive" title="Verification List">
        <img
          [src]="rlvlistMember.isActive ? '/side-panel/verification-list-blue.svg' : '/side-panel/verification-list.svg'"
          class="nav-icon" alt="" />
        Verification List
      </a>
    </li>
    <!-- <li class="nav-item">
      <a class="nav-link-item" routerLink="/admin/audit-list" routerLinkActive="active"
        #rlalistMember="routerLinkActive" title="Audit List">
        <img
          [src]="rlalistMember.isActive ? '/side-panel/audit-list-blue.svg' : '/side-panel/audit-list.svg'"
          class="nav-icon" alt="" />
        Audit List
      </a>
    </li> -->
    <!-- <li class="nav-item">
      <a class="nav-link-item" routerLink="/admin/canon-list" routerLinkActive="active"
        #rlclistMember="routerLinkActive" title="Canon List">
        <img
          [src]="rlclistMember.isActive ? '/side-panel/canon-list-blue.svg' : '/side-panel/canon-list.svg'"
          class="nav-icon" alt="" />
        Canon List
      </a>
    </li> -->
    <!-- <li class="nav-item">
      <a class="nav-link-item" routerLink="/admin/verification-history" routerLinkActive="active"
        #rlvhMember="routerLinkActive" title="Verification History">
        <img [src]="rlvhMember.isActive ? '/side-panel/verification-history-blue.svg' : '/side-panel/verification-history.svg'"
          class="nav-icon" alt="" />
        Verification History
      </a>
    </li> -->
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/admin/callback-request" routerLinkActive="active"
        #rlcrMember="routerLinkActive" title="Callback Request">
        <img [src]="rlcrMember.isActive ? '/side-panel/MyRequirements-blue.svg' : '/side-panel/MyRequirements-gray.svg'"
          class="nav-icon" alt="" />
        Callback Request
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/admin/add-article" routerLinkActive="active" #rlaMember="routerLinkActive"
        title="New Article">
        <img [src]="rlaMember.isActive ? '/icons/new-article-white.svg' : '/icons/new-article.svg'" class="nav-icon"
          alt="" />
        New Article
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/admin/manage-intents" routerLinkActive="active"
        #rlcatMember="routerLinkActive" title="Intents">
        <img [src]="rlcatMember.isActive ? '/icons/available-contract-white.svg' : '/icons/available-contract.svg'"
          class="nav-icon" alt="" />
        Contracts
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/admin/manage-users" routerLinkActive="active" #rluMember="routerLinkActive"
        title="Manage Users">
        <img [src]="rluMember.isActive ? '/icons/manage-users-white.svg' : '/icons/manage-users.svg'" class="nav-icon"
          alt="" />
        Manage Users
      </a>
    </li>

    } @else if (isPrivileged(['INVESTOR_ADMIN', 'IS_INVESTOR', 'IS_INVESTOR_ADMIN'])){
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/investor/market-intelligence" routerLinkActive="active"
        #rld="routerLinkActive" title="Dashboard">
        <img [src]="rld.isActive ? '/side-panel/Tradegpt-blue.svg' : '/side-panel/Tradegpt-gray.svg'" class="nav-icon"
          alt="" />
        Dashboard
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/investor/portfolio" routerLinkActive="active" #rlpo="routerLinkActive"
        title="Portfolio">
        <img [src]="rlpo.isActive ? '/side-panel/Portfolio-blue.svg' : '/side-panel/Portfolio-gray.svg'"
          class="nav-icon" alt="" />
        Portfolio
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/investor/proposal-list" routerLinkActive="active" #rlpr="routerLinkActive"
        title="Proposals">
        <img [src]="rlpr.isActive ? '/side-panel/MyQuotes-blue.svg' : '/side-panel/MyQuotes-gray.svg'" class="nav-icon"
          alt="" />
        Available Contract
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/investor/intents" routerLinkActive="active" #rlic="routerLinkActive"
        title="Intents">
        <img [src]="rlic.isActive ? '/side-panel/MyOrders-blue.svg' : '/side-panel/MyOrders-gray.svg'" class="nav-icon"
          alt="" />
        Invested Contract
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link-item" routerLink="/investor/wallet" routerLinkActive="active" #rlw="routerLinkActive"
        title="Wallet">
        <img [src]="rlw.isActive ? '/side-panel/MyRequirements-blue.svg' : '/side-panel/MyRequirements-gray.svg'"
          class="nav-icon" alt="" />
        Wallet
      </a>
    </li>
    }

    <!-- <li class="nav-item">
      <a class="nav-link-item" routerLink="/verification/verification-summary" routerLinkActive="active" #rlv="routerLinkActive" title="Verify Users">
        <img [src]="rlv.isActive ? '/side-panel/Profile.svg' : '/side-panel/Profile-gray.svg'" class="nav-icon-profile"
          alt="Verify Users" />
        Verify Users
      </a>
    </li> -->

    <li class="nav-item">
      <a class="nav-link-item" routerLink="/profile" routerLinkActive="active" #rlp="routerLinkActive" title="Profile">
        <img [src]="rlp.isActive ? '/side-panel/Profile.svg' : '/side-panel/Profile-gray.svg'" class="nav-icon-profile"
          alt="Profile" />
        Profile
      </a>
    </li>

  </ul>

  <!-- Chat history section (if any) -->
  <!-- <div class="px-3 pb-3" *ngIf="chatHistory.length > 0">
    <div class="d-flex justify-content-between align-items-center mb-2">
      <h6 class="mb-0" style="color: #080b53; font-size: 0.8rem; font-weight: 600;">Chat history</h6>
      <i class="bi bi-pencil-square add-new-chat" style="color: #080b53; cursor: pointer;" (click)="addNewChat()"></i>
    </div>
    <div class="overflow-y-auto" style="max-height: 150px;">
      @for(chat of chatHistory; track $index){
      <div style="font-size: 11px; padding: 4px 8px; border-radius: 6px; cursor: pointer;"
        class="truncate-text text-muted hover-bg" (click)="openTradeGPT(chat)">
        {{chat.question}}
      </div>
      }
    </div>
  </div> -->

  <!-- Footer / User -->
  <div class="sidebar-footer">
    <div class="user-row" routerLink="/profile" style="cursor: pointer;">
      <div class="user-avatar">{{user?.firstName?.charAt(0)}}{{user?.lastName?.charAt(0)}}</div>
      <div>
        <div class="user-name">{{user?.firstName}} {{user?.lastName}}</div>
        <div class="user-role">{{user?.userType | uppercase}}</div>
      </div>
    </div>
    <hr class="divider">
    <button class="logout-btn" (click)="logout()">
      <!-- <i class="bi bi-box-arrow-right logout-icon"></i> -->
      <!-- <img [src]="'/icons/logout.svg'" class="nav-icon" alt="Logout" /> -->
      <div class="icon-wrap">
        <img src="/icons/logout.svg" class="icon-default" alt="Logout" />
        <img src="/icons/logout-white.svg" class="icon-hover" alt="Logout" />
      </div>
      Log out
    </button>
  </div>

</aside>
<nav class="bottom-nav d-lg-none" style="overflow: visible;">
  @let visibleItems = getVisibleNavItems();
  @let hiddenItems = getHiddenNavItems();
  <!-- @let secondaryActive = isSecondaryActive(); -->

  @for(item of visibleItems; track item.label) {
  <a class="nav-item-mob" [routerLink]="item.route" (click)="item.click ? item.click() : null" routerLinkActive="active"
    [routerLinkActiveOptions]="{ exact: false }">
    <div class="icon-box">
      <img [src]="getItemIcon(item)" alt="" />
    </div>
    <span class="nav-label">{{ item.label }}</span>
  </a>
  }

  <a class="nav-item-mob" [class.active]="isAnyRouteActive(hiddenItems)" [matMenuTriggerFor]="mobileMoreMenu">
    <div class="icon-box">
      <i class="bi bi-three-dots" style="font-size: 1.5rem; color: #9ca3af;"></i>
    </div>
    <span class="nav-label">More</span>
  </a>

  <mat-menu #mobileMoreMenu="matMenu" xPosition="before" class="mobile-more-menu">
    @for(item of hiddenItems; track item.label) {
    <button mat-menu-item [routerLink]="item.route" (click)="item.click ? item.click() : null">
      <img [src]="getItemIcon(item)" class="menu-icon" alt="" />
      <span>{{ item.label }}</span>
    </button>
    } 
  </mat-menu>
</nav>